import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, defaultLocale } from "./translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [locale, setLocale] = useState(() => {
    if (typeof window === "undefined") return defaultLocale;
    return localStorage.getItem("esra.locale") || defaultLocale;
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("esra.locale", locale);
      document.documentElement.lang = locale;
    }
  }, [locale]);

  const value = useMemo(() => {
    const t = translations[locale] || translations[defaultLocale];
    return { locale, setLocale, t };
  }, [locale]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
